/**
 * The drawer's slide-out duration, shared by the drawer components and the route-change delay so
 * navigation can't unmount a drawer partway through its animation.
 *
 * Its own module so neither drawer component has to import the other — that edge would pull the
 * dev-mode JSON viewer into node-environment tests that never render a drawer.
 */
export const drawerCloseAnimationMs = 250;
